/**
 * Pages légales du site vitrine. Seules les versions /fr/ et /en/ existent :
 * les adresses sans préfixe de langue renvoient 404.
 */
const LEGAL_BASE_URL = 'https://unboared.com';

export type LegalLinks = { terms: string; privacy: string };

/**
 * Liens CGU + confidentialité dans la langue réellement affichée :
 * français → /fr/, toute autre langue (ou inconnue) → /en/.
 */
export function getLegalLinks(language?: string): LegalLinks {
    const [base] = (language || '').toLowerCase().split('-');
    const prefix = base === 'fr' ? 'fr' : 'en';
    return {
        terms: `${LEGAL_BASE_URL}/${prefix}/terms-of-use`,
        privacy: `${LEGAL_BASE_URL}/${prefix}/privacy-policy`,
    };
}
